import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  FaShieldAlt,
  FaBolt,
  FaUniversalAccess,
  FaArrowRight,
} from "react-icons/fa";
import JsonData from "../data/data.json";

const BANK_NAME = JsonData?.Header?.nameBank || "CORE bank";
const BANK_DOMAIN = JsonData?.Header?.nameBankDomain || "corebankdigital";
const REGISTER_URL = `https://app.${BANK_DOMAIN}.com.br/register`;
const LOGIN_URL = `https://app.${BANK_DOMAIN}.com.br/login`;

const SLIDER_SETTINGS = {
  dots: true,
  infinite: true,
  speed: 600,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: true,
  pauseOnHover: true,
  adaptiveHeight: false,
  centerMode: false,
  variableWidth: false,
};

const SLIDES = [
  {
    image: "/img/3slide.webp",
    badge: "Digital Banking",
    title: "O banco digital que entende a",
    highlight: "velocidade do seu dia",
    subtitle: `Conta, Pix, crédito e investimentos em um só app. Tudo o que você precisa, com a segurança que o ${BANK_NAME} entrega.`,
  },
  {
    image: "/img/header.webp",
    badge: "Investimentos",
    title: "Faça seu dinheiro",
    highlight: "render com inteligência",
    subtitle: `Renda fixa, fundos e tesouro direto com curadoria do ${BANK_NAME}. Transparência total, taxas justas e zero burocracia.`,
  },
  {
    image: "/img/bank-metta.webp",
    badge: "Para sua empresa",
    title: "Banking que acompanha",
    highlight: "o ritmo do seu negócio",
    subtitle: `Maquininha, Pix ilimitado, antecipação e folha de pagamento — tudo integrado à sua conta empresarial CORE bank.`,
  },
];

const TRUST_ITEMS = [
  { icon: <FaShieldAlt />, label: "Regulado pelo Banco Central" },
  { icon: <FaBolt />, label: "Pix 24/7, gratuito" },
  { icon: <FaUniversalAccess />, label: "LGPD & Open Finance" },
];

const openInNewTab = (url) => {
  window.open(url, "_blank", "noreferrer");
};

const SlideItem = ({ slide }) => (
  <div className="slide-wrapper">
    <div className="slide-image">
      <img
        src={slide.image}
        alt={slide.title}
        loading="lazy"
        className="slide-img"
      />
      <div className="overlay">
        <div className="hero-mesh" aria-hidden="true"></div>
        <div className="container">
          <div className="row">
            <div className="col-md-10 col-md-offset-1 col-xs-12 intro-text">
              <span className="hero-badge">
                <span className="hero-badge-dot" aria-hidden="true"></span>
                {slide.badge}
              </span>
              <h1 className="hero-title">
                {slide.title}
                {slide.highlight && (
                  <>
                    <br />
                    <span className="hero-highlight">{slide.highlight}</span>
                  </>
                )}
              </h1>
              <p className="hero-subtitle">{slide.subtitle}</p>
              <div className="hero-ctas">
                <button
                  type="button"
                  className="btn hero-btn hero-btn--primary"
                  onClick={() => openInNewTab(REGISTER_URL)}
                  aria-label="Abrir minha conta CORE bank"
                >
                  Abrir minha conta
                  <FaArrowRight className="hero-btn-icon" aria-hidden="true" />
                </button>
                <button
                  type="button"
                  className="btn hero-btn hero-btn--ghost"
                  onClick={() => openInNewTab(LOGIN_URL)}
                  aria-label="Acessar minha conta CORE bank"
                >
                  Acessar conta
                </button>
              </div>
              <ul className="hero-trust" aria-label="Diferenciais e segurança">
                {TRUST_ITEMS.map((item, idx) => (
                  <li key={idx} className="hero-trust-item">
                    <span className="hero-trust-icon" aria-hidden="true">
                      {item.icon}
                    </span>
                    <span>{item.label}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export const Slidershow = () => {
  if (SLIDES.length === 1) {
    return (
      <div className="slideshow">
        <SlideItem slide={SLIDES[0]} />
      </div>
    );
  }

  return (
    <div className="slideshow">
      <Slider {...SLIDER_SETTINGS}>
        {SLIDES.map((slide, index) => (
          <SlideItem key={index} slide={slide} />
        ))}
      </Slider>
    </div>
  );
};
